import React from 'react'
import { Link } from 'react-router-dom'

import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../AppInsights';


class AccessDenied extends React.Component {
  render() {
    return (
      <div>
          <aside className="main_content">
            <p >Access Denied</p>
            <Link to="/">Go to Home </Link>
          </aside>
      </div>
    )
  }
}

export default withAITracking(reactPlugin, AccessDenied, 'Aceess Denied', 'AccessDenied')